import SimpleHomeBreadcrumb from '@Components/Shared/SimpleHomeBreadcrumb';
import InfoSection from '@Components/Info/InfoSection';

const ScamView = (props) => {
    return (
        <div className='info-content-container'>
            <div className='info-content-header'>
                <SimpleHomeBreadcrumb homeRoute={props.BreadCrumbHomeRoute} displayText={props.BreadCrumbText} />
                <div className='pagename-container border-bottom'>
                    <h1 className='pagename'>{props.PageTitle}</h1>
                    <a href='/info/contact-us?ofs=1'><i class="fa fa-envelope" aria-hidden="true" aria-label={translator.translate('sandhills.tradepubwebsite.mvc.contactus')}></i></a>
                </div>
            </div>
            <div className='scam-container'>
                {props.Sections.map((obj, i) =>
                    <InfoSection {...obj} key={i} />)}
            </div>
        </div>
    );
};

export default ScamView;
global.ScamView = ScamView;